<template>
  <div class="container page" >
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar><div style="width:100%;padding-left: 2.667vw;padding-right: 2.667vw"><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.old_pwd")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="old_password"
                type="digit"
                :placeholder="$t('setting.old_pwd_tip')"
              />
              
            </div>
          </div><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.new_pwd")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="o_new_password"
                type="digit"
                :placeholder="$t('setting.new_pwd_tip')"
              />
              
            </div>
          </div><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("my.old_pwd")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="t_new_password"
                type="digit"
                :placeholder="$t('setting.new_again_tip')"
              />
              
            </div>
          </div><div @click="save()" style="height:40px;width:100%;background: linear-gradient(180deg, #fc78af, #f22678);color:#fff;font-size: 16px;text-align: center;border-radius: 10px;line-height: 40px;margin-top: 10px;">{{$t("my.msg42")}}</div>
</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password:"",
      t_new_password:"",
      old_password:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.old_password === "" || this.old_password === null || this.old_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.o_new_password !== this.t_new_password){
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          old_password:this.old_password,
          new_password:this.o_new_password,
        },
        url: 'user_set_loginpw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);

        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .wrapper{
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}
.container .wrapper .item .title{
  margin: 40px 0;
  line-height: 20px;
  font-size: 30px;
  font-weight: 500;
  color: #000;
  text-align: center;
}.nav-bar{background: linear-gradient(180deg, #fc78af, #f22678);}
::v-deep .van-password-input{
  width: 80%;
  height: 150px;
  margin: 0 auto;

}
::v-deep .van-password-input__security li {
  font-size: 30px;
  line-height: 30;
  background-color: #ebedf0;
}
::v-deep .van-password-input__security {
  height: 130px;
}
::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 30px;
}
.van-password-input__security i {
  width: 25px;
  height: 25px;
}
::v-deep .van-key {
  height: 100px;
  font-size: 55px;
  line-height: 20px;
  border-radius: 20px;
}.van-cell {
  font-size: 30px;
  line-height: 50px;
}
::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f2f3f5;
}
::v-deep .van-key__collapse-icon {
   width: 50px;
   height: 50px;
 }
::v-deep .van-key__delete-icon {
  width: 50px;
  height: 50px;
}
.container .wrapper .sub-btn{
  margin: 110px 0 0 10%;
  height: 100px;
  width: 80%;
  font-size: 35px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
}
</style>
